import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll en window
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    // Scroll en el contenedor principal de Layout
    const layoutContent = document.querySelector('.layout-content');
    if (layoutContent) {
      layoutContent.scrollTop = 0;
    }

    // Segundo intento después de un frame para asegurar
    requestAnimationFrame(() => {
      window.scrollTo(0, 0);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;

      const layoutContent = document.querySelector('.layout-content');
      if (layoutContent) {
        layoutContent.scrollTop = 0;
      }
    });

    // Tercer intento con un pequeño delay para páginas que cargan contenido dinámico
    setTimeout(() => {
      const layoutContent = document.querySelector('.layout-content');
      if (layoutContent) {
        layoutContent.scrollTop = 0;
      }
    }, 100);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
